/**
 * Proiectul Firebase al fiecarei gazde - `resources/js/push_notifications/config.js`
 * din portal, cuvant cu cuvant.
 *
 * Un proiect Firebase e per regiune si per cont, nu per vhost: mai multe gazde
 * impart acelasi proiect (`local` il ia pe al lui `beta`, `my` pe al lui `us`,
 * CEC pe al Europei). Fara intrare aici, `pushConfigFor` intoarce `null` si
 * notificarile push pur si simplu nu pornesc, fara nicio eroare - exact ce
 * facea si portalul cu `{}`.
 *
 * ACEEASI TABELA STA SI IN `public/firebase-messaging-sw.js`: lucratorul de
 * fundal nu poate importa nimic din pachet, deci o poarta pe a lui. Proba
 * `pushNotifications.test.ts` le compara, ca o gazda adaugata intr-una si
 * uitata in cealalta sa nu treaca.
 */
export interface FirebaseWebConfig {
  apiKey: string
  authDomain: string
  databaseURL: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
}

const BETA: FirebaseWebConfig = {
  apiKey: 'AIzaSyCvMujaTyWB9dia7HfzBrpsmx8ncIxvTk4',
  authDomain: 'optimumdesk-beta.firebaseapp.com',
  databaseURL: 'https://optimumdesk-beta.firebaseio.com',
  projectId: 'optimumdesk-beta',
  storageBucket: 'optimumdesk-beta.appspot.com',
  messagingSenderId: '869086476784',
  appId: '1:869086476784:web:9df4fa0c012e4a9a220535',
}

const US: FirebaseWebConfig = {
  apiKey: 'AIzaSyC9pRsY98JdWrRCeUueQCM3W4guckN5-PQ',
  authDomain: 'optimumdesk-sua.firebaseapp.com',
  databaseURL: 'https://optimumdesk-sua.firebaseio.com',
  projectId: 'optimumdesk-sua',
  storageBucket: 'optimumdesk-sua.appspot.com',
  messagingSenderId: '824643025352',
  appId: '1:824643025352:web:6477577c8ab820aeee28fd',
}

const EUROPE: FirebaseWebConfig = {
  apiKey: 'AIzaSyDtq25iF82BsPLu2ajmNnjM54uRlmvP-I4',
  authDomain: 'optimumdesk-europe.firebaseapp.com',
  databaseURL: 'https://optimumdesk-europe.firebaseio.com',
  projectId: 'optimumdesk-europe',
  storageBucket: 'optimumdesk-europe.appspot.com',
  messagingSenderId: '1048287795060',
  appId: '1:1048287795060:web:dc5687412c0217a60f3e21',
}

const USW: FirebaseWebConfig = {
  apiKey: 'AIzaSyAA-vCpQXbcU4jeolPt-ucPxzVNSlubHCw',
  authDomain: 'optimumdesk-usw.firebaseapp.com',
  databaseURL: 'https://optimumdesk-usw.firebaseio.com',
  projectId: 'optimumdesk-usw',
  storageBucket: 'optimumdesk-usw.appspot.com',
  messagingSenderId: '800214475830',
  appId: '1:800214475830:web:18bcc70daa9e848667a497',
}

export const PUSH_CONFIG: Record<string, FirebaseWebConfig> = {
  'beta.optimumdesk.com': BETA,
  'local.optimumdesk.com': BETA,
  'us.optimumdesk.com': US,
  'my.optimumdesk.com': US,
  /* CEC foloseste proiectul Europe, ca instalarea europeana. */
  'cec.optimumdesk.com': EUROPE,
  'eu.optimumdesk.com': EUROPE,
  'usw.optimumdesk.com': USW,
  'myw.optimumdesk.com': USW,
}

export function pushConfigFor(hostname: string): FirebaseWebConfig | null {
  return PUSH_CONFIG[hostname] ?? null
}
